import Button from "../../common/components/Button";
import useTranslation from "../../common/translations";
import { useOfferFiltersState } from "../context/OfferFiltersContext";
import React from "react";
export default function FilterSubmitFooter({ onSubmit, className = "w-full", }) {
    const { t } = useTranslation("offer-filters");
    const { offersCount, loadingFacets } = useOfferFiltersState();
    return (<div className="px-4 py-4 border-t border-[#D8DFE0]">
      <Button type="button" onClick={onSubmit} className={className}>
        {loadingFacets
            ? t("submit.loading")
            : t("submit.show_results_with_count").replace("{count}", String(offersCount))}
      </Button>
    </div>);
}
